import { allModels, ioViewer } from "../IntraoralManager";

//#region Fields

const angle90 = (90 * Math.PI) / 180;
const angle180 = (180 * Math.PI) / 180;

const dy = 3;
const dz = 5;

let numberOptionsInitialized = false;
let maxBox = null;
let maxCenter = null;
let mandBox = null;
let mandCenter = null;
let numbersVisible = false;
let allTeeth = null;
let lastTicks = Date.now();

//#endregion

//#region Init

async function initToothNumberOptions() {
  if (!numberOptionsInitialized) {
    ioViewer.controls.addEventListener("change", onCameraChangeForNumbers);

    maxBox = getTeethBox(true);
    maxCenter = new THREE.Vector3(
      maxBox.center.x,
      maxBox.max.y - maxBox.size.y / 3,
      maxBox.center.z,
    );

    mandBox = getTeethBox(false);
    mandCenter = new THREE.Vector3(
      mandBox.center.x,
      mandBox.max.y - mandBox.size.y / 3,
      mandBox.center.z,
    );

    let teeth = allModels.filter((x) => x.isTooth);
    teeth.forEach((tooth) => {
      try {
        // let mesh = ioViewer.get_model_mesh(tooth.id);
        var mesh = tooth.mainMesh;
        if (mesh && !mesh.textPoint) {
          let center = tooth.isMaxilla ? maxCenter : mandCenter;
          let box = tooth.defaultBox;

          let x = box.center.x;
          let y = box.center.y;
          let z = box.center.z;
          mesh.apexCenter = new THREE.Vector3(x, y, z);
          //   drawPoint(mesh.apexCenter, 0x00ff00, false, 0.4, ioViewer);

          let distance = calculateDistance(mesh.apexCenter, center);
          let coef = (distance + dz * 2) / distance;
          let px = (x - center.x) * coef + center.x;
          let py = (y - center.y) * coef + center.y;
          let pz = (z - center.z) * coef + center.z;
          mesh.textPoint = new THREE.Vector3(px, py, pz);
          //   drawPoint(mesh.textPoint, 0x0000ff, false, 0.4, ioViewer);
          //   drawLine(mesh.textPoint, mesh.apexCenter, 0xff0000, ioViewer);

          mesh.apexEdge = mesh.apexCenter;
        }
      } catch (error) {
        console.log("initToothNumberOptions ERROR", error, tooth);
      }
    });
  }
}

function getTeethBox(isMaxilla) {
  var min = { x: 100000, y: 100000, z: 100000 };
  var max = { x: -10000, y: -100000, z: -100000 };
  var teethBox = { min, max };
  allModels.forEach(function (model) {
    // var mesh = ioViewer.get_model_mesh(model.id);
    var mesh = model.mainMesh;
    if (
      mesh &&
      model.isTooth &&
      (isMaxilla == null || model.isMaxilla == isMaxilla)
    ) {
      var geometry = mesh.geometry.clone();
      geometry.applyMatrix4(mesh.matrix);
      var toothBox = geometry.boundingBox;
      if (toothBox.min.x < teethBox.min.x) {
        teethBox.min.x = toothBox.min.x;
      }
      if (toothBox.min.y < teethBox.min.y) {
        teethBox.min.y = toothBox.min.y;
      }
      if (toothBox.min.z < teethBox.min.z) {
        teethBox.min.z = toothBox.min.z;
      }
      if (toothBox.max.x > teethBox.max.x) {
        teethBox.max.x = toothBox.max.x;
      }
      if (toothBox.max.y > teethBox.max.y) {
        teethBox.max.y = toothBox.max.y;
      }
      if (toothBox.max.z > teethBox.max.z) {
        teethBox.max.z = toothBox.max.z;
      }
    }
  });
  teethBox = offsetBox(teethBox, 0, 0, 0, 0);
  //   drawBox(teethBox, null, ioViewer);
  return teethBox;
}

//#endregion

function onCameraChangeForNumbers(controls) {
  const currentTicks = Date.now();
  if (numbersVisible && allTeeth && currentTicks - lastTicks > 10) {
    lastTicks = currentTicks;
    for (const tooth of allTeeth) {
      if (tooth.numberLabel) {
        drawToothNumber(tooth);
      }
    }
  }
}

async function drawTeethNumbers(isUpper) {
  // ioViewer = ioViewer;
  allTeeth = allModels.filter(
    (x) => x.isTooth && x.isUpper === isUpper && !x.isDeleted,
  );

  await initToothNumberOptions();

  allTeeth.forEach((tooth) => {
    try {
      showToothNumber(tooth);
    } catch (error) {
      console.log("drawTeethNumbers ERROR", error, tooth);
    }
  });

  numbersVisible = true;
}

function showToothNumber(tooth) {
  if (tooth) {
    drawToothNumber(tooth, true);
    tooth.numberLabel.style.display = "block";
  }
}

function removeTeethNumbers() {
  if (numbersVisible && allTeeth) {
    for (const tooth of allTeeth) {
      tooth.numberLabel.style.display = "none";
    }
  }
  numbersVisible = false;
}

function drawToothNumber(tooth, updateText) {
  let canvasHalfWidth = ioViewer.renderer.domElement.offsetWidth / 2;
  let canvasHalfHeight = ioViewer.renderer.domElement.offsetHeight / 2;
  let mesh = tooth.mesh;
  // let mesh = ioViewer.get_model_mesh(model.id);

  let objectCenter = mesh.textPoint;
  let centerPosition = new THREE.Vector3(
    objectCenter.x,
    objectCenter.y,
    objectCenter.z,
  );
  centerPosition = centerPosition.project(ioViewer.camera);
  centerPosition.x = centerPosition.x * canvasHalfWidth + canvasHalfWidth;
  centerPosition.y = -(centerPosition.y * canvasHalfHeight) + canvasHalfHeight;

  let numberLabel = tooth.numberLabel;
  if (!numberLabel) {
    numberLabel = tooth.numberLabel = document.createElement("div");
    numberLabel.style.color = `${tooth.color}`;
    numberLabel.style.border = `2px solid ${tooth.color}`;
    numberLabel.style.position = "absolute";
    // measureLabel.style.zIndex = "9999";
    numberLabel.style.width = "auto";
    numberLabel.style.height = "auto";
    numberLabel.style.padding = "2px";
    numberLabel.style.pointerEvents = "none";
    // measureLabel.style.opacity = "0.5";
    numberLabel.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
    numberLabel.style.display = "none";
    numberLabel.style.maxWidth = "85px";
    numberLabel.style.minWidth = "32px";

    numberLabel.textContent = `${tooth.number}`;

    document.getElementById("intraoralViewer").appendChild(numberLabel);
  }
  if (updateText) numberLabel.textContent = `${tooth.number}`;

  numberLabel.style.left = `${centerPosition.x - 35}px`;
  numberLabel.style.top = `${centerPosition.y}px`;
  return numberLabel;
}

export {
  initToothNumberOptions,
  drawTeethNumbers,
  removeTeethNumbers,
  showToothNumber,
};
